import { render, staticRenderFns } from "./StoryCard.vue?vue&type=template&id=20dc4a89&scoped=true"
import script from "./StoryCard.vue?vue&type=script&lang=js"
export * from "./StoryCard.vue?vue&type=script&lang=js"
import style0 from "./StoryCard.vue?vue&type=style&index=0&id=20dc4a89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dc4a89",
  null
  
)

export default component.exports